import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SendIcon, PaperclipIcon, UserIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface LiveChatProps {
  navigate: (screen: string) => void;
}
export function LiveChat({
  navigate
}: LiveChatProps) {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{
    id: 1,
    text: 'Hello! Welcome to Skydd Support. How can we help you today?',
    sender: 'agent',
    time: '10:00 AM'
  }]);
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;
    const newMsg = {
      id: Date.now(),
      text: message,
      sender: 'user',
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages([...messages, newMsg]);
    setMessage('');
    // Simulate agent response
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        text: 'Thank you for your message. An agent will be with you shortly.',
        sender: 'agent',
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      }]);
    }, 1000);
  };
  return <div className="flex-1 bg-slate-50 flex flex-col h-full" data-id="element-2229">
      <TopBar title="Live Chat" showBack onBack={() => navigate('profile')} data-id="element-2230" />

      <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-2231">
        {messages.map(msg => <motion.div key={msg.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-2232">
            <div className={`max-w-[80%] flex gap-2 ${msg.sender === 'user' ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-2233">
              {msg.sender === 'agent' && <div className="w-8 h-8 rounded-full bg-[#0D3B3B] flex items-center justify-center shrink-0" data-id="element-2234">
                  <UserIcon className="w-4 h-4 text-white" data-id="element-2235" />
                </div>}

              <div data-id="element-2236">
                <div className={`p-3 rounded-2xl ${msg.sender === 'user' ? 'bg-[#0D3B3B] text-white rounded-tr-sm' : 'bg-white border border-gray-100 shadow-sm text-gray-800 rounded-tl-sm'}`} data-id="element-2237">
                  <p className="text-sm" data-id="element-2238">{msg.text}</p>
                </div>
                <p className={`text-[10px] text-gray-400 mt-1 ${msg.sender === 'user' ? 'text-right' : 'text-left'}`} data-id="element-2239">
                  {msg.time}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="p-4 bg-white border-t border-gray-100 pb-safe" data-id="element-2240">
        <form onSubmit={handleSend} className="flex items-center gap-2" data-id="element-2241">
          <button type="button" className="p-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2242">
            <PaperclipIcon className="w-5 h-5" data-id="element-2243" />
          </button>
          <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Type a message..." className="flex-1 bg-gray-50 border-transparent rounded-full py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D3B3B]/20 focus:bg-white transition-all" data-id="element-2244" />
          <button type="submit" disabled={!message.trim()} className="w-10 h-10 rounded-full bg-[#0D3B3B] text-white flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed transition-opacity" data-id="element-2245">
            <SendIcon className="w-4 h-4 -ml-0.5" data-id="element-2246" />
          </button>
        </form>
      </div>
    </div>;
}